const virginParticular1 = [
    {
        "tipoVenta": "ALTA_NUEVA",
        "tipoLinea": "LINEA_ADICIONAL",
        "tarifa": {
            "id": "PPOSCONVERGENTVIRGIN4",
            "price": 42.1488,
            "name": "Fibra 300 Mb + Gigas Infinitos",
            "operator": "VIRGIN",
            "segment": "PARTICULAR",
            "category": "convergent",
            "color": null,
            "commercial_enrichment": null,
            "description_file": null,
            "fixed_line_info": null,
            "mobile_line_info": null,
            "payment_type": "postpaid",
            "is_active": true,
            "created_on": "2022-05-25T00:45:13.938041+02:00",
            "updated_on": "2022-05-25T00:45:13.946057+02:00",
            "svas": [],
            "promotions": [
                "PROMOVIRGIN4"
            ],
            "additional_lines": [
                "PADICIONALGIGASINFINITOS(FMC50GB/INFINITOS)\nVIRGIN",
                "PADICIONAL50GBVIRGIN"
            ]
        },
        "cacharro": null,
        "installment": null,
        "seguro": null,
        "lineasAsociadas": [],
        "crossSell": false,
        "promotion": []
    }
]
export default virginParticular1;